// Where the players sit at a 牌桌 (card table: 德州扑克 and the other card games), for everyone: the office
// (src/office/tables/cards.ts places and turns seated players, walks an agent to its seat) and the page
// (public/cards.js walks you there, deck/entities.js CardTables draws the stools). Pure, no DOM.
// A card table is a point in the map (MAP.cardTables, {id, x, y} in tiles); its felt is an oval round the middle of
// that tile. A game with n seats puts them evenly on a bigger oval round it, seat 0 at the bottom, then on round
// clockwise as the screen shows it (left, top, right): the way cards are dealt. Positions are an otter's (sprite
// top-left, as everywhere; feet at x + 0.5, y + 0.8).

/** The felt's half-width and half-height (tiles), and the seats' oval (where the feet go). */
export const FELT = { rx: 1.7, ry: 0.95 };
export const SEAT_OVAL = { rx: 3, ry: 1.95 };
/** Close enough to sit (tiles, feet to the seat's spot), as the office checks it. */
export const CARD_SIT_REACH = 2;
/** Close enough to sit or watch from (tiles, feet to the table's middle). */
export const cardTableDist = (t, x, y) => Math.hypot(x + 0.5 - (t.x + 0.5), y + 0.8 - (t.y + 0.5));

/** Seat i (0-based) of n at `table`: {x, y} the otter's position, {fx, fy} its feet, {dir, dir8, dir16} facing the
 *  middle of the table, {tx, ty} its feet's tile. */
export function cardSeat(table, i, n) {
  const a = Math.PI / 2 + (i * 2 * Math.PI) / n, cx = table.x + 0.5, cy = table.y + 0.5;
  const fx = +(cx + Math.cos(a) * SEAT_OVAL.rx).toFixed(2), fy = +(cy + Math.sin(a) * SEAT_OVAL.ry).toFixed(2);
  const dx = cx - fx, dy = cy - fy;
  const dir = Math.abs(dx) * SEAT_OVAL.ry >= Math.abs(dy) * SEAT_OVAL.rx * 1.05 ? (dx > 0 ? 1 : 3) : dy > 0 ? 0 : 2;
  return { x: +(fx - 0.5).toFixed(2), y: +(fy - 0.8).toFixed(2), fx, fy, tx: Math.floor(fx), ty: Math.floor(fy), dir, dir8: dir * 2, dir16: dir * 4 };
}
/** The free seat nearest to (x, y) (an otter's position) among `free` (seat indices), or -1. */
export function nearestCardSeat(table, n, free, x, y) {
  let best = -1, bd = Infinity;
  for (const i of free) { const s = cardSeat(table, i, n), d = Math.hypot(s.x - x, s.y - y); if (d < bd) { bd = d; best = i; } }
  return best;
}
